var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Purpose",
    transform: "translate(1.338 1.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5809",
    "data-name": "Path 5809",
    d: "M4.765,23.208c12.843,0,18.443-5.4,18.443-18.443,0,13.039,5.56,18.443,18.442,18.443-12.882,0-18.442,5.56-18.442,18.442C23.208,28.768,17.608,23.208,4.765,23.208Z",
    transform: "translate(15.012 15.012)",
    fill: "none",
    stroke: "#2aad8f",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5810",
    "data-name": "Path 5810",
    d: "M.663,12.519c8.256,0,11.856-3.474,11.856-11.856,0,8.382,3.574,11.856,11.856,11.856-8.281,0-11.856,3.574-11.856,11.856,0-8.281-3.6-11.856-11.856-11.856Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#2aad8f",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpose);
export default __webpack_public_path__ + "static/media/Purpose.6cdeeabd80b5235915ae256194beaa5f.svg";
export { ForwardRef as ReactComponent };